
let productSelectionButtonClicked = false,
    productSelectionIndex,
    selectedProducts = [];
document.querySelectorAll('.lsg-bundle-block').forEach(() => {
    selectedProducts.push([]);
})

const buildSelectedProductArray = (trigger) => {
    const method = (trigger.classList.contains('lsg-bundle-product-select-quantity-minus') ? 'minus' : (trigger.classList.contains('lsg-bundle-product-select-quantity-plus') ? 'plus' : 'err'));
    const triggeredProductWrapper = trigger.closest('.lsg-bundle-product-select-wrapper');
    const variantID = triggeredProductWrapper.getAttribute('data-lsg-bundle-variant-select-id');
    const productTitle = triggeredProductWrapper.querySelector('.lsg-bundle-product-select-title').innerHTML;
    const bundleBlock = getBundleBlock(trigger);
    const bundleIndex0 = Array.from(bundleBlock.parentNode.children).indexOf(bundleBlock);
    
    switch(method) {
        case 'minus':
            if (productSelectionButtonClicked == true) {
                selectedProducts[bundleIndex0].splice(productSelectionIndex, 1);
                productSelectionButtonClicked = false
            }
            else {
                productSelectionIndex = selectedProducts[bundleIndex0].findLastIndex(p => p.selectedVariantId == variantID);
                selectedProducts[bundleIndex0].splice(productSelectionIndex, 1);    
            }
            break;
        case 'plus':
            const productImageUrl = triggeredProductWrapper.querySelector('img').src;
            const productImageAlt = triggeredProductWrapper.querySelector('img').alt;
            let selectedProductData = {
                selectedProductImageUrl: productImageUrl,
                selectedVariantId: variantID,
                selectedProductTitle: productTitle,
                selectedProductImageAlt: productImageAlt,
            };
            selectedProducts[bundleIndex0].push(selectedProductData);
            break;
    }
    updateSelectedProductGUI(trigger);
}

const updateSelectedProductGUI = (trigger) => {
    const bundleBlock = getBundleBlock(trigger);
    const bundleIndex0 = Array.from(bundleBlock.parentNode.children).indexOf(bundleBlock);
    if (selectedProducts[bundleIndex0].length > 0) {
        bundleBlock.classList.add('has-selected-product');
    } else {
        bundleBlock.classList.remove('has-selected-product');
    }

    const selectedProductsWrappers = bundleBlock.querySelectorAll('[data-bundle-builder-selected-products]');
    selectedProductsWrappers.forEach((selectedProductsWrapper) => {
        const selectedProductWrappers = selectedProductsWrapper.querySelectorAll('[data-bundle-builder-selected-variant-id]');
    
        selectedProductWrappers.forEach((productWrapper, i) => {
            const selectedProductData = selectedProducts[bundleIndex0][i];
    
            const productWrapperImage = productWrapper.querySelector('[data-bundle-builder-selected-product-image]');
            const productWrapperTitle = productWrapper.querySelector('[data-bundle-builder-selected-product-title]');
    
            if (typeof selectedProductData !== 'undefined') {
                
                productWrapper.setAttribute('data-bundle-builder-selected-variant-id', selectedProductData.selectedVariantId);
    
                productWrapperImage.src = selectedProductData.selectedProductImageUrl;
                productWrapperImage.alt = selectedProductData.selectedProductImageAlt;
    
                productWrapperTitle.innerHTML = selectedProductData.selectedProductTitle;
    
                productWrapper.classList.add('active');
            } else {
                
                productWrapper.setAttribute('data-bundle-builder-selected-variant-id', '');
                
                productWrapperImage.src = '';
                productWrapperImage.alt = '';
    
                productWrapperTitle.innerHTML = '';
    
                productWrapper.classList.remove('active');
                
            }
        });
    });
    
}

function setActiveBundle(trigger) {
    //sets different bundle blocks active
    const bundleIndex = trigger.dataset.bundleIndex;
    const bundleWrapper = trigger.closest('.lsg-bundle-wrapper');
    const bundleBlocks = bundleWrapper.querySelectorAll('.lsg-bundle-block');
    const targetBundle = bundleWrapper.querySelector('[data-bundle-index="' + bundleIndex + '"].lsg-bundle-block');
    if(targetBundle) {
        bundleBlocks.forEach(function(bundleBlock){
            if(bundleBlock.dataset.bundleIndex != bundleIndex) {
                bundleBlock.classList.remove('lsg-bundle-block-active');
            } else {
                bundleBlock.classList.add('lsg-bundle-block-active');
            }
        });
        updateSelectedProductGUI(trigger);
        setUrl(targetBundle.querySelector('form'));
    }
}
function getDefaultBundleIndexFromPath() {
  const p = (window.location.pathname || '').toLowerCase();

  // Ajustá estos índices según el orden REAL de tus bloques:
  // (en tu screenshot parece: 36=0, 24=1, 18=2, 12=3)
  if (p.includes('bundle-36-cans')) return 0;
  if (p.includes('bundle-24-cans')) return 1;
  if (p.includes('bundle-18-cans')) return 2;
  if (p.includes('bundle-12-cans')) return 3;

  return 0; // fallback
}

function checkParameter() {
  const urlParams = new URLSearchParams(window.location.search);
  const bundleBlocks = document.querySelectorAll('.lsg-bundle-block');
  const queryString = window.location.search;

  const bundles = urlParams.getAll('bundle'); // legacy: bundle=ID_QTY
let bundle_index = urlParams.get('bundle_index');
if (bundle_index === null) bundle_index = getDefaultBundleIndexFromPath();
  bundle_index = parseInt(bundle_index, 10);
  if (isNaN(bundle_index) || bundle_index < 0 || bundle_index >= bundleBlocks.length) bundle_index = 0;

  const bundleBlock = bundleBlocks[bundle_index];
  if (!bundleBlock) return;

  // Si en esta página hay selector interno de bundles (multi-block)
  if (bundle_index > 0) {
    const bundleBlockSelects = document.querySelectorAll('.lsg-bundle-size-select .lsg-bundle-size-select-el');
    if (bundleBlockSelects[bundle_index]) bundleBlockSelects[bundle_index].click();
  }

  // -----------------------------
  // NEW: apply interval + frequency FIRST (so max/min are correct)
  // NEW: support ordered carryover via bundle_item=ID (repeated)
  // -----------------------------
  const bundle_items = urlParams.getAll('bundle_item'); // ordered list
  const desiredInterval = urlParams.get('bundle_interval'); // 'otp' | 'sub'
  const desiredFrequency = urlParams.get('bundle_interval_frequency');

  // 1) Apply interval first
  if (desiredInterval) {
    const packSizeSelectorItem = bundleBlock.querySelector(
      `.lsg-bundle-interval-select input[name^="bundle_interval_select_"][value="${desiredInterval}"]`
    );
    if (packSizeSelectorItem) {
      packSizeSelectorItem.checked = true;
      updateInterval(packSizeSelectorItem);
      checkoutEnableValidation(packSizeSelectorItem);
    }
  }

  // 2) Apply frequency (if sub)
 const bundleIntervalFrequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
if (bundleIntervalFrequencySelect) {
  if (desiredFrequency) {
    const opt = bundleIntervalFrequencySelect.querySelector(`option[value="${CSS.escape(desiredFrequency)}"]`);
    if (opt) {
      bundleIntervalFrequencySelect.value = desiredFrequency;
    } else {
      // el selling_plan id no existe en este bundle -> fallback seguro
      bundleIntervalFrequencySelect.selectedIndex = 0;
    }
  } else if (bundleIntervalFrequencySelect.selectedIndex < 0) {
    bundleIntervalFrequencySelect.selectedIndex = 0;
  }

  updateFrequency(bundleIntervalFrequencySelect);
}


  // Resolve interval safely from classes
  const resolvedInterval =
    (bundleBlock.classList.contains('lsg-bundle--sub-selected') || bundleBlock.classList.contains('lsg-bundle--only-sub'))
      ? 'sub'
      : 'otp';

  let resolvedMax =
    resolvedInterval === 'otp'
      ? parseInt(bundleBlock.dataset.otpBundleMax || '0', 10)
      : parseInt(bundleBlock.dataset.subBundleMax || '0', 10);

  if (isNaN(resolvedMax) || resolvedMax < 1) resolvedMax = 0; // 0 => no max

  function addOneByVariantId(variantId) {
    const quantityInput = bundleBlock.querySelector(
      `.lsg-bundle-product-select-quantity-input[data-product="${variantId}"]`
    );
    if (!quantityInput) return false;

    const wrap = quantityInput.closest('.lsg-bundle-product-select-quantity-wrap');
    const plusBtn = wrap ? wrap.querySelector('.lsg-bundle-product-select-quantity-plus') : null;
    if (!plusBtn) return false;

    const before = parseInt(quantityInput.value, 10) || 0;
    incrementSubProduct(plusBtn);
    const after = parseInt(quantityInput.value, 10) || 0;

    if (after > before) {
      buildSelectedProductArray(plusBtn);
      incrementEnableValidation(plusBtn);
      checkoutEnableValidation(plusBtn);
      return true;
    }
    return false;
  }

  // 3) Prefer bundle_item (ordered) -> perfect truncate on 6->2
  if (bundle_items && bundle_items.length) {
    const toApply = (resolvedMax > 0) ? bundle_items.slice(0, resolvedMax) : bundle_items;
    toApply.forEach((id) => addOneByVariantId(id));
  } else {
    // Fallback legacy "bundle=id_qty"
    bundles.forEach((el) => {
      const item = el.split('_');
      const id = item[0];
      const quantity = parseInt(item[1], 10) || 0;
      if (quantity <= 0) return;

      let currentQty = 0;
      bundleBlock.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach((input) => {
        currentQty += (parseInt(input.value, 10) || 0);
      });

      let canAdd = quantity;
      if (resolvedMax > 0) {
        const remaining = resolvedMax - currentQty;
        if (remaining <= 0) return;
        canAdd = Math.min(quantity, remaining);
      }

      for (let i = 0; i < canAdd; i++) {
        const ok = addOneByVariantId(id);
        if (!ok) break;
      }
    });
  }

  // (Opcional) dejar URL intacta como tu código original
  if (history.pushState) {
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + queryString;
    window.history.pushState({ path: newurl }, '', newurl);
  }
}


function setUrl(trigger) {
    const bundleBlockWrapper = trigger.closest('.lsg-bundle-wrapper');
    if (bundleBlockWrapper && !bundleBlockWrapper.hasAttribute('data-lsg-bundle-set-url')) {
        return false;
    }
    const bundleBlock = getBundleBlock(trigger);
    const quantityInput = bundleBlock.querySelectorAll('.lsg-bundle-product-select-quantity-input');
    let url = '?';
    let paramName = 'bundle';
    quantityInput.forEach((el) => {
        const value = el.value;
        if (value > 0) {
            url += (url == '?') ? '' : '&';
            url += `${paramName}=${el.getAttribute('data-product')}_${value}`;
        }
    });
    const selectedBundle = bundleBlock.closest('.lsg-bundle-wrapper').querySelector('.lsg-bundle-block.lsg-bundle-block-active');
    if (selectedBundle != null) {
        paramName = 'bundle_index';
        url += (url == '?') ? '' : '&';
        url += `${paramName}=${Array.from(selectedBundle.parentNode.children).indexOf(selectedBundle)}`;
    }
    const bundleIntervalOption = bundleBlock.querySelector('.lsg-bundle-interval-select input[type="radio"]:checked');
    if (bundleIntervalOption != null) {
        paramName = 'bundle_interval';
        url += (url == '?') ? '' : '&';
        url += `${paramName}=${bundleIntervalOption.value}`;
        if (bundleIntervalOption.value == 'sub') {
            paramName = 'bundle_interval_frequency';
            url += (url == '?') ? '' : '&';
            const bundleIntervalFrequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');

            if (bundleIntervalFrequencySelect != null) {
                url += `${paramName}=${bundleIntervalFrequencySelect.value}`;
            }
        }
    }
    if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + url;
        window.history.pushState({path: newurl}, '', newurl);
    }
}

function incrementEnableValidation(trigger) {
    //trigger is input or increment buttons
    const productSetList = trigger.closest('.lsg-bundle-product-set-list');
    const quantityIncrementButtons = productSetList.querySelectorAll('.lsg-bundle-product-select-quantity-increment');
    const bundleQuantity = getBundleQuantityByChild(trigger);
    const bundleMax = productSetList.dataset.bundleMax;

    //increment button enable/disable
    quantityIncrementButtons.forEach(function(quantityIncrementButton){
        const method = (quantityIncrementButton.classList.contains('lsg-bundle-product-select-quantity-minus') ? 'minus' : (quantityIncrementButton.classList.contains('lsg-bundle-product-select-quantity-plus') ? 'plus' : 'err'));
        const input = quantityIncrementButton.closest('.lsg-bundle-product-select-quantity-wrap').querySelector('.lsg-bundle-product-select-quantity-input');
        const quantity = input.value;
        switch(method) {
            case 'minus':
                quantityIncrementButton.disabled = false;
                if(quantity <= 0) {
                    quantityIncrementButton.disabled = true;
                }
                if(quantity <= parseInt(input.min)) {
                    quantityIncrementButton.disabled = true;
                }
                break;
            case 'plus':
                quantityIncrementButton.disabled = false;
                if(quantity >= parseInt(input.max)) {
                    quantityIncrementButton.disabled = true;
                }
                if(parseInt(bundleMax) > 0) {
                    if(bundleQuantity >= parseInt(bundleMax)) {
                        quantityIncrementButton.disabled = true;
                    }
                }
                break;
        }
    });
}

function checkoutEnableValidation(trigger) {
    const bundleBlock = getBundleBlock(trigger);
    const addToCartButtons = bundleBlock.querySelectorAll('[data-lsg-bundle-atc]');
    const bundleQuantity = getBundleQuantity(trigger);
    const interval = getBundleInterval(trigger);
    const bundleMin = (interval == 'otp' ? bundleBlock.dataset.otpBundleMin : bundleBlock.dataset.subBundleMin);
    const bundleMax = (interval == 'otp' ? bundleBlock.dataset.otpBundleMax : bundleBlock.dataset.subBundleMax);
    const quantityToAdd = bundleMin - bundleQuantity;

    //checkout button enable/disable
    addToCartButtons.forEach(function(addToCartButton){
        const addToCartText = addToCartButton.querySelector('[data-lsg-bundle-submit-button-atc-text]'); 
        const addMoreText = addToCartButton.querySelector('[data-lsg-bundle-submit-button-add-more-text]');
        const addMoreQuantity = addToCartButton.querySelector('[data-lsg-bundle-submit-button-add-more-quantity]');

        if(bundleQuantity >= bundleMin && (bundleQuantity <= bundleMax || bundleMax < bundleMin)) {
            addToCartButton.classList.remove('disabled');
            addToCartText.classList.remove('hidden');
            addMoreText.classList.add('hidden');
            bundleBlock.classList.add('bundle-checkout-enabled');
        } else {
            addToCartButton.classList.add('disabled');
            addToCartText.classList.add('hidden');
            addMoreText.classList.remove('hidden');
            addMoreQuantity.innerHTML = quantityToAdd;
            bundleBlock.classList.remove('bundle-checkout-enabled');
        }
    });
}

function addToCart(trigger) {
    const bundleID = getGuid();
    const bundleBlock = getBundleBlock(trigger);
    const bundleForm = bundleBlock.querySelector('.lsg-bundle-form');
    const bundleProductID = bundleForm.querySelector('input[name="id"]').value;
    const bundleSellingPlan = bundleForm.querySelector('input[name="selling_plan"]').value;
    const interval = (bundleSellingPlan == '' ? 'otp' : 'sub');
    const bundleMin = (interval == 'otp' ? bundleBlock.dataset.otpBundleMin : bundleBlock.dataset.subBundleMin);
    const bundleMax = (interval == 'otp' ? bundleBlock.dataset.otpBundleMax : bundleBlock.dataset.subBundleMax);
    const bundleProductList = bundleBlock.querySelector('.lsg-bundle-product-set-list');
    const bundleProductListInputs = bundleProductList.querySelectorAll('.lsg-bundle-product-select-quantity-input');
    let bundleCart = {
        'items': []
    };
    let bundleProductQuantity = 0;
    {
        let cartItem = {
            id: bundleProductID,
            quantity: 1,
            properties: {
              "bundle_id": bundleID,
              "bundle_parent": true,
            },
        };
        if (interval == 'sub') {
            cartItem["selling_plan"] = bundleSellingPlan;
        }
        bundleCart.items.push(cartItem);
    }
    bundleProductListInputs.forEach(function(bundleProductInput){
        bundleProductQuantity = bundleProductQuantity + parseInt(bundleProductInput.value);
        if(parseInt(bundleProductInput.value) > 0) {
            let cartItem = {
                id: bundleProductInput.dataset.product,
                quantity: parseInt(bundleProductInput.value),
                properties: {
                    "bundle_id": bundleID,
                },
            };
            if (interval == 'sub') {
                cartItem["selling_plan"] = bundleSellingPlan;
            }
            bundleCart.items.push(cartItem);
        }
    });
    if(bundleProductQuantity > bundleMax || bundleProductQuantity < bundleMin) {
        //quantity is not within bundle size
        return false;
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(bundleCart),
        credentials: 'same-origin'
    }).then((response) => {
        if(response.status == 200) {
            // window.location.href = "/cart";
            lsgSlideCartOpen();
        }
    }).catch((error) => {
        console.error(error);
    });
}

function updateFrequency(trigger) {
    //Render price and assign selling_plan in the form
    updateBundlePrice(trigger);
    updateSellingPlan(trigger);
}

function updateInterval(trigger) {
    //updates bundle block classes, resets displayed prices, and sets the selling_plan input value
    const bundleBlock = getBundleBlock(trigger);
    const sellingPlanInput = bundleBlock.querySelector('.lsg-bundle-form input[name="selling_plan"]');
    const frequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');

    switch(trigger.value) {
        case 'otp':
            bundleBlock.classList.remove('lsg-bundle--sub-selected');
            bundleBlock.classList.add('lsg-bundle--otp-selected');
            sellingPlanInput.value = '';
            break;
        case 'sub':
            bundleBlock.classList.remove('lsg-bundle--otp-selected');
            bundleBlock.classList.add('lsg-bundle--sub-selected');
            sellingPlanInput.value = frequencySelect.value;
            break;
    }

    updateBundlePrice(trigger);
    updateSellingPlan(trigger);
}

function updateSellingPlan(trigger) {
    //set form selling_plan based on selected state
    const bundleBlock = getBundleBlock(trigger);
    const selling_plan = bundleBlock.querySelector('.lsg-bundle-form input[name="selling_plan"]');
    if(selling_plan) {
        if(bundleBlock.classList.contains('lsg-bundle--sub-selected') || bundleBlock.classList.contains('lsg-bundle--only-sub')) {
            const frequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
            if(frequencySelect) {
                selling_plan.value = frequencySelect.value;
            } else {
                selling_plan.value = '';
            }
        } else {
            selling_plan.value = '';
        }
    }
}

function inputChangeSubProduct(trigger) {
    //validates quantities for bundle products when the input field is updated
    if(isNaN(trigger.value) || trigger.value == ''){
        trigger.value = 0;
    }

    if(trigger.value > parseInt(trigger.max)) {
        trigger.value = parseInt(trigger.max);
    }

    if(trigger.value < 0) {
        trigger.value = 0;
    }

    if(trigger.value < parseInt(trigger.min)) {
        trigger.value = parseInt(trigger.min);
    }

    const bundleMax = trigger.closest('.lsg-bundle-product-set-list').dataset.bundleMax;
    const bundleQuantity = getBundleQuantity(trigger);

    if((bundleQuantity > bundleMax) && bundleMax > 0) {
        let bundleDif = bundleQuantity - bundleMax;
        if(trigger.value >= bundleDif) {
            //reduce quantity to stay within bundle max
            trigger.value = (trigger.value - bundleDif);
        } else {
            //something went wrong, reset all values to min
            trigger.closest('.lsg-bundle-product-set-list').querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input){
                input.value = parseInt(input.min);
            });
        }
    }
    updateQuantityDisplay(trigger);
    updateBundlePrice(trigger);
}

function incrementSubProduct(trigger) {
    //validates quantities for the bundle products and updates the input when increment buttons are clicked
    const method = (trigger.classList.contains('lsg-bundle-product-select-quantity-minus') ? 'minus' : (trigger.classList.contains('lsg-bundle-product-select-quantity-plus') ? 'plus' : ''));
    const input = trigger.closest('.lsg-bundle-product-select-quantity-wrap').querySelector('.lsg-bundle-product-select-quantity-input');
    const bundleMax = trigger.closest('.lsg-bundle-product-set-list').dataset.bundleMax;
    const bundleQuantity = getBundleQuantity(trigger);

    switch(method) {
        case 'plus':
            if(input.value >= parseInt(input.max)) {
                //reset to inventory max if over
                input.value = parseInt(input.max);
            } else {
                if((bundleQuantity < parseInt(bundleMax)) || parseInt(bundleMax) < 1) {
                    input.value++;
                } else {
                    //at max bundle quantity, do not change
                }
            }
            updateBundlePrice(trigger);
            break;
        case 'minus':
            if(input.value <= parseInt(input.min)) {
                input.value = parseInt(input.min);
            } else if(input.value <= 0) {
                input.value = 0;
            } else {
                input.value--;
            }
            updateBundlePrice(trigger);
            break;
    }
    updateQuantityDisplay(input);
    mirrorQuantityDisplay(input);
}

function mirrorQuantityDisplay(input) {
    const bundleBlock = getBundleBlock(input);
    const productID = input.dataset.product;
    const quantity = input.value;
    const productInputs = bundleBlock.querySelectorAll('[data-product="' + productID + '"].lsg-bundle-product-select-quantity-input');
    productInputs.forEach(function(productInput){
        if(productInput !== input) {
            productInput.value = quantity;
            inputChangeSubProduct(productInput);
        }
    });
}

function updateQuantityDisplay(input) {
    const inputWrap = input.closest('.lsg-bundle-product-select-quantity-wrap');
    if (input.value <= 0) {
        $(inputWrap).addClass('no-quantity');
    } else {
        $(inputWrap).removeClass('no-quantity');
    }
    const inputDisplay = input.parentNode.querySelector('.lsg-bundle-product-select-quantity-input-display');
    if(inputDisplay) {
        inputDisplay.innerHTML = input.value;
    }
}

function updateBundlePrice(trigger) {
    //updates OTP/Sub pricing
    const bundleBlock = getBundleBlock(trigger);
    const otpPriceEls = bundleBlock.querySelectorAll('.lsg-bundle-interval-otp-price');
    const subPriceEls = bundleBlock.querySelectorAll('.lsg-bundle-interval-sub-price');
    const curPriceEls = bundleBlock.querySelectorAll('[data-bundle-total]');
    const frequencySelectEl = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
const frequency = frequencySelectEl
  ? (frequencySelectEl.selectedOptions && frequencySelectEl.selectedOptions[0]) || frequencySelectEl.options[0]
  : null;

    const productList = bundleBlock.querySelector('.lsg-bundle-product-set-list');
    const hasIntervalSelect = !!bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');

    const productBasePrice = parseInt(bundleBlock.dataset.productBasePrice);
    let interval = ''
    if(bundleBlock.classList.contains('lsg-bundle--only-otp') || bundleBlock.classList.contains('lsg-bundle--otp-selected')) {
        interval = 'otp';
    } else if (bundleBlock.classList.contains('lsg-bundle--only-sub') || bundleBlock.classList.contains('lsg-bundle--sub-selected')) {
        interval = 'sub';
    }
    let otpSubtotal = 0;
    let subSubtotal = 0;

    if(productList && interval == 'otp') {
        productList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(otpProductInput){
            let quantity = parseInt(otpProductInput.value);
            let price = parseInt(otpProductInput.dataset.price);
            otpSubtotal = otpSubtotal + (quantity * price);
           if (productList && frequency) {
                const discountType = frequency.dataset.discountType;
                const discountValue = frequency.dataset.discountValue;
                let discount = 0;
                switch(discountType){
                    case 'percentage':
                        discount = (price * parseInt(discountValue)) / 100;
                        break;
                    case 'fixed_amount':
                        discount = parseInt(discountValue);
                        break;
                    case 'price':
                        discount = price - parseInt(discountValue);
                        break;
                }
                subSubtotal = subSubtotal + (quantity * (price - discount));
            }
        });
    }

    if(productList && frequency && interval == 'sub') {
        const discountType = frequency.dataset.discountType;
        const discountValue = frequency.dataset.discountValue;
        productList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(subProductInput){
            let quantity = parseInt(subProductInput.value);
            let price = parseInt(subProductInput.dataset.price);
            let discount = 0;
            switch(discountType){
                case 'percentage':
                    discount = (price * parseInt(discountValue)) / 100;
                    break;
                case 'fixed_amount':
                    discount = parseInt(discountValue);
                    break;
                case 'price':
                    discount = price - parseInt(discountValue);
                    break;
            }
            subSubtotal = subSubtotal + (quantity * (price - discount));

            if (productList) {
            otpSubtotal = otpSubtotal + (quantity * price);
            }
        });
    }

    if (otpSubtotal > 0) {
        otpSubtotal = otpSubtotal + productBasePrice;
    }
    if (subSubtotal > 0) {
        const discountType = frequency.dataset.discountType;
        const discountValue = frequency.dataset.discountValue;
        let discount = 0;
        switch(discountType){
            case 'percentage':
                discount = (productBasePrice * parseInt(discountValue)) / 100;
                break;
            case 'fixed_amount':
                discount = parseInt(discountValue);
                break;
                case 'price':
                discount = productBasePrice - parseInt(discountValue);
                break;
            }
        if(discount < 0) { discount = 0; }
        subSubtotal = subSubtotal + (productBasePrice - discount);
    }
const visualSubDiscount = parseFloat(bundleBlock.dataset.subBundleDiscount || '');

if (!isNaN(visualSubDiscount) && visualSubDiscount > 0) {
  let rawSubtotal = 0;

  if (productList) {
    productList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input) {
      const quantity = parseInt(input.value, 10) || 0;
      const price = parseInt(input.dataset.price, 10) || 0;

      if (quantity > 0) {
        rawSubtotal += quantity * price;
      }
    });
  }
    if (rawSubtotal > 0) {
    rawSubtotal += productBasePrice;
    subSubtotal = Math.round(rawSubtotal * (100 - visualSubDiscount) / 100);
  }
}
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    otpPriceEls.forEach(function(el){
        el.innerHTML = currencyFormatter.format(otpSubtotal / 100);
    });
    subPriceEls.forEach(function(el){
        el.innerHTML = currencyFormatter.format(subSubtotal / 100);
    });
    curPriceEls.forEach(function(el){
        if (interval == 'otp') {
            el.innerHTML = currencyFormatter.format(otpSubtotal / 100);
        } else {
            el.innerHTML = currencyFormatter.format(subSubtotal / 100);
        }
    });
}

function initializeBundle() {
    //loop through bundle blocks
    document.querySelectorAll('.lsg-bundle-block').forEach(function(bundleBlock){
        //set bundle block classes and initial selling_plan input
        const intervalSelect = bundleBlock.querySelector('.lsg-bundle-interval-select');
        const onlyOTP = bundleBlock.querySelector('.lsg-bundle-interval-only-otp');
        const onlySub = bundleBlock.querySelector('.lsg-bundle-interval-only-sub');
        const sellingPlanInput = bundleBlock.querySelector('.lsg-bundle-form input[name="selling_plan"]');
        const frequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
        if(intervalSelect){
            //has otp/sub selector
            bundleBlock.classList.add('lsg-bundle--has-interval-select');
            let selectedInterval = intervalSelect.querySelector('input[name^="bundle_interval_select_"]:checked');
            switch(selectedInterval.value){
                case 'otp':
                    bundleBlock.classList.add('lsg-bundle--otp-selected');
                    sellingPlanInput.value = '';
                    break;
                case 'sub':
                    bundleBlock.classList.add('lsg-bundle--sub-selected');
                    sellingPlanInput.value = frequencySelect.value;
                    break;
            }
        } else if (onlyOTP) {
            //has only otp options
            bundleBlock.classList.add('lsg-bundle--only-otp');
            sellingPlanInput.value = '';
        } else if (onlySub) {
            //has only sub options
            bundleBlock.classList.add('lsg-bundle--only-sub');
            sellingPlanInput.value = frequencySelect.value;
        }

        //intial enable/disable for quantity increments and submit button
        bundleBlock.querySelectorAll('.lsg-bundle-product-set-list').forEach(function(productSetList){
            incrementEnableValidation(productSetList.querySelector('.lsg-bundle-product-select-quantity-input'));
        });
        checkoutEnableValidation(sellingPlanInput);
        setTimeout(function(){
            bundleBlock.classList.add('is-initialized');
        }, 500);
    });
    checkParameter();
}

function getBundleQuantity(trigger) {
    //gets the quantity of the current active bundle block product list
    let bundleBlock = getBundleBlock(trigger);
    let quantity = -1;
    let productList = bundleBlock.querySelector('.lsg-bundle-product-set-list');
    if(productList){
        quantity = 0;
        productList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input){
            quantity = quantity + parseInt(input.value);
        });
    }
    return quantity;
}

function getBundleQuantityByChild(trigger){
    const productSetList = trigger.closest('.lsg-bundle-product-set-list');
    let quantity = -1;
    if(productSetList){
        quantity = 0;
        productSetList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input){
            quantity = quantity + parseInt(input.value);
        });
    }
    return quantity;
}

function getBundleInterval(trigger) {
    //checks if the bundle is set to display OTP or suscription options
    let bundleBlock = getBundleBlock(trigger);
    if(bundleBlock.classList.contains('lsg-bundle--has-interval-select')) {
        if(bundleBlock.classList.contains('lsg-bundle--otp-selected')) {
            return 'otp';
        }
        if(bundleBlock.classList.contains('lsg-bundle--sub-selected')) {
            return 'sub';
        }
    }
    if(bundleBlock.classList.contains('lsg-bundle--only-otp')) {
        return 'otp';
    }
    if(bundleBlock.classList.contains('lsg-bundle--only-sub')) {
        return 'sub';
    }
    return 'err';
}

function getBundleBlock(trigger) {
    return trigger.closest('.lsg-bundle-block');
}

function getGuid() {
    let d = new Date().getTime();
    let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
    });
}

//Event Listeners
if (document.addEventListener) {
    window.addEventListener('pageshow', function (event) {
      if (event.persisted || performance.getEntriesByType("navigation")[0].type === 'back_forward') {
        document.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input){
            input.value = 0;
            inputChangeSubProduct(input);
            incrementEnableValidation(input);
            checkoutEnableValidation(input);
        });
      }
    },
    false);
}

document.querySelectorAll('[data-bundle-builder-selected-product-remove-button]').forEach(function(removeButton){
    removeButton.addEventListener('click', function(e){
        e.preventDefault();
        const triggeredProductWrapper = e.target.closest('[data-bundle-builder-selected-variant-id]');
        productSelectionButtonClicked = true;
        productSelectionIndex = triggeredProductWrapper.getAttribute('data-index');
        const variantID = triggeredProductWrapper.getAttribute('data-bundle-builder-selected-variant-id');
        const bundleBlock = getBundleBlock(e.currentTarget);
        const bundleProduct = bundleBlock.querySelector(`[data-lsg-bundle-variant-select-id='${variantID}']`);
        const bundleProductDecrement = bundleProduct.querySelector('.lsg-bundle-product-select-quantity-minus');
        bundleProductDecrement.click();
    });
});

document.querySelectorAll('.lsg-bundle-product-select-quantity-increment').forEach(function(incrementButton){
    incrementButton.addEventListener('click', function(e){
        e.preventDefault();
        incrementSubProduct(e.currentTarget);
        buildSelectedProductArray(e.currentTarget);
        incrementEnableValidation(e.currentTarget);
        checkoutEnableValidation(e.currentTarget);
        setUrl(e.currentTarget);
    })
});
document.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input){
    input.addEventListener('change', function(e){
        inputChangeSubProduct(e.currentTarget);
        incrementEnableValidation(e.currentTarget);
        checkoutEnableValidation(e.currentTarget);
    })
});
document.querySelectorAll('.lsg-bundle-interval-select input[name^="bundle_interval_select_"]').forEach(function(intervalSelector){
    intervalSelector.addEventListener('change', function(e){
        updateInterval(e.currentTarget);
        checkoutEnableValidation(e.currentTarget);
        setUrl(e.currentTarget);
    });
});
document.querySelectorAll('.lsg-bundle-interval-frequency-select').forEach(function(frequencySelect){
    frequencySelect.addEventListener('change', function(e){
        const trigger = e.currentTarget;
        updateFrequency(e.currentTarget);
        setUrl(e.currentTarget);
    })
});
document.querySelectorAll('[data-lsg-bundle-atc]').forEach((bundleATC) => {
    bundleATC.addEventListener('click', function(e){
        e.preventDefault();
        if(e.currentTarget.classList.contains('disabled')) {
            //scroll to top of the bundle block
            const announcementOffset = parseInt(document.body.style.getPropertyValue('--announcement-offset').replace('px', '')) || 0;
            const headerOffset = parseInt(document.body.style.getPropertyValue('--header-offset').replace('px', '')) || 0;
            const offset = announcementOffset + headerOffset;
            const bundleBlock = getBundleBlock(e.currentTarget);
            window.scrollTo({ top: bundleBlock.offsetTop - offset, behavior: 'smooth' });
        } else {
            addToCart(e.currentTarget);
        }
    })
})
document.querySelectorAll('.lsg-bundle-size-select-el').forEach(function(bundleSelector){
    bundleSelector.addEventListener('click', function(e){
        e.preventDefault();
        setActiveBundle(e.currentTarget);
    });
});

//Run initialize
initializeBundle();

const bundleObserver = new IntersectionObserver(([entry]) => {
    const bundleBlock = entry.target.closest('.lsg-bundle-block');
    if(bundleBlock) {
        bundleBlock.classList.remove('summary-is-below');
        bundleBlock.classList.remove('summary-is-above');
        bundleBlock.classList.remove('summary-is-visible');
        
        if(entry.isIntersecting) {
            // is visible
            bundleBlock.classList.add('summary-is-visible');
            return
        } else if(entry.boundingClientRect.top > 0) {
            // item is below view
            bundleBlock.classList.add('summary-is-below');
        } else {
            // item is above view
            bundleBlock.classList.add('summary-is-above');
        }
    }
});
const buyboxes = document.querySelectorAll('.lsg-bundle-summary-block');
buyboxes.forEach((buybox) => {
    bundleObserver.observe(buybox);
});

const bottomObserver = new IntersectionObserver(([entry]) => {
    const bundleBlocks = document.querySelectorAll('.lsg-bundle-block');
    if(entry.isIntersecting) {
        bundleBlocks.forEach((bundleBlock) => {
            bundleBlock.classList.add('is-scroll-bottom');
        })
    } else {
        bundleBlocks.forEach((bundleBlock) => {
            bundleBlock.classList.remove('is-scroll-bottom');
        })
    }
}, {
    threshold: 1
});
const subFooter = document.querySelector('.io-sub-footer');
if (subFooter) {
    bottomObserver.observe(subFooter);
}


(function () {
  if (window.__lsgOtpVisualDiscountInit) return;
  window.__lsgOtpVisualDiscountInit = true;

  function getActiveBadgePct(root) {
  var dataPct = parseFloat(root.getAttribute('data-otp-bundle-discount'));

  if (!isNaN(dataPct) && dataPct > 0) {
    return dataPct;
  }

  var badge = root.querySelector('.bundle-size-option--active .canscircle__badge');
  if (!badge) return 0;

  var m = (badge.textContent || '').match(/(\d+(?:\.\d+)?)\s*%/);
  return m ? parseFloat(m[1]) : 0;
}

  function parseMoneyToCents(text) {
    if (!text) return null;

    var s = text.replace(/[^\d.,]/g, '');
    if (!s) return null;

  
    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');
    var decSep = null;

    if (lastDot > -1 && lastComma > -1) {
      decSep = (lastDot > lastComma) ? '.' : ',';
    } else if (lastComma > -1) {

      decSep = (s.length - lastComma - 1 === 2) ? ',' : null;
    } else if (lastDot > -1) {
      decSep = (s.length - lastDot - 1 === 2) ? '.' : null;
    }

    var integerPart = s;
    var decimalPart = '';

    if (decSep) {
      var parts = s.split(decSep);
      integerPart = parts[0];
      decimalPart = (parts[1] || '').slice(0, 2);
    }


    integerPart = integerPart.replace(/[.,]/g, '');
    if (!integerPart) integerPart = '0';
    if (decimalPart.length === 1) decimalPart = decimalPart + '0';
    if (decimalPart.length === 0) decimalPart = '00';

    var cents = parseInt(integerPart, 10) * 100 + parseInt(decimalPart, 10);
    return isNaN(cents) ? null : cents;
  }

  function formatCents(root, cents) {
    var moneyFormat = root.getAttribute('data-money-format');
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && moneyFormat) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function applyVisualDiscount(root) {
  var pct = getActiveBadgePct(root);
  var els = root.querySelectorAll('.lsg-bundle-interval-otp-price');
  if (!els.length) return;

  var productList = root.querySelector('.lsg-bundle-product-set-list');
  var base = parseInt(root.dataset.productBasePrice || '0', 10) || 0;

  var hasItems = false;
  var childrenCents = 0;

  if (productList) {
    productList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function (input) {
      var q = parseInt(input.value, 10) || 0;
      if (q <= 0) return;

      hasItems = true;

      var price = parseInt(input.dataset.price, 10) || 0; // cents

      // ✅ Shopify-style: descuento truncado (floor) POR UNIDAD
      if (pct > 0) {
        var unitDiscount = Math.floor((price * pct) / 100);
        var unitNet = price - unitDiscount;
        childrenCents += unitNet * q;
      } else {
        // sin descuento -> raw
        childrenCents += price * q;
      }
    });
  }

  // igual que tu lógica original: base solo si hay algo seleccionado
  var centsToShow = hasItems ? (childrenCents + base) : 0;
  var textToShow = formatCents(root, centsToShow);

  els.forEach(function (el) {
    var currentText = (el.textContent || '').trim();
    if (el.dataset.discountedText && currentText === el.dataset.discountedText) return;

    el.dataset.discountedText = textToShow;
    el.textContent = textToShow;
  });
}




  function watchRoot(root) {
    if (root.dataset.otpVisualWatcher === '1') return;
    root.dataset.otpVisualWatcher = '1';

    applyVisualDiscount(root);

    
    var mo = new MutationObserver(function () {
      applyVisualDiscount(root);
    });

    mo.observe(root, { childList: true, subtree: true, characterData: true });
  }

  function init() {
   
    document.querySelectorAll('.lsg-bundle-block').forEach(watchRoot);

   
    var bodyObserver = new MutationObserver(function () {
      document.querySelectorAll('.lsg-bundle-block').forEach(watchRoot);
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



/* bundle 4 options in the same file */

// ------------------------------------------------------------
// Carry-over selection across product pages (12/18/24/36 links)
// Uses URL params so the next product page rehydrates via checkParameter()
// ------------------------------------------------------------
(function () {
  function getActiveBundleBlock() {
    return document.querySelector('.lsg-bundle-block.lsg-bundle-block-active') || document.querySelector('.lsg-bundle-block');
  }

  function getBundleIndex0(bundleBlock) {
    if (!bundleBlock || !bundleBlock.parentNode) return 0;
    return Array.from(bundleBlock.parentNode.children).indexOf(bundleBlock);
  }

  function getIntervalFromBlock(bundleBlock) {
    if (!bundleBlock) return 'otp';
    if (bundleBlock.classList.contains('lsg-bundle--sub-selected') || bundleBlock.classList.contains('lsg-bundle--only-sub')) return 'sub';
    return 'otp';
  }

  function getFrequencyFromBlock(bundleBlock) {
    if (!bundleBlock) return '';
    const sel = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
    return sel ? (sel.value || '') : '';
  }

  // Build an ordered list of selected variant IDs (preserves order as user added them)
  function getSelectedVariantIdsOrdered(bundleBlock) {
    const idx0 = getBundleIndex0(bundleBlock);

    // Prefer your selectedProducts array (preserves selection order)
    let list = [];
    try {
      if (Array.isArray(selectedProducts) && Array.isArray(selectedProducts[idx0]) && selectedProducts[idx0].length) {
        list = selectedProducts[idx0]
          .map(p => String(p.selectedVariantId || '').trim())
          .filter(Boolean);
      }
    } catch (_) {}

    // Fallback: expand from quantity inputs (order = DOM order)
    if (!list.length) {
      const inputs = bundleBlock.querySelectorAll('.lsg-bundle-product-select-quantity-input');
      inputs.forEach((input) => {
        const id = String(input.dataset.product || '').trim();
        const q = parseInt(input.value, 10) || 0;
        if (!id || q <= 0) return;
        for (let i = 0; i < q; i++) list.push(id);
      });
    }

    return list;
  }

  function buildCarryoverQuery(bundleBlock) {
    const params = new URLSearchParams();

    const interval = getIntervalFromBlock(bundleBlock);
    params.set('bundle_interval', interval);

    const freq = getFrequencyFromBlock(bundleBlock);
    if (interval === 'sub' && freq) params.set('bundle_interval_frequency', freq);

    // Preserve order + allow perfect truncate: bundle_item repeated
    const items = getSelectedVariantIdsOrdered(bundleBlock);
    items.forEach((id) => params.append('bundle_item', id));

    // Optional: keep compatibility with your existing bundle_index behavior
    //params.set('bundle_index', String(getBundleIndex0(bundleBlock)));

    return params.toString();
  }

  // Intercept clicks on your size links (12/18/24/36)
  document.querySelectorAll('.bundle-size-option').forEach((a) => {
    a.addEventListener('click', function (e) {
      const href = a.getAttribute('href');
      if (!href) return;

      const bundleBlock = getActiveBundleBlock();
      if (!bundleBlock) return;

      const qs = buildCarryoverQuery(bundleBlock);

      // If nothing selected, let it navigate normally
      // (still carries interval, but no items)
      e.preventDefault();

      const url = new URL(href, window.location.origin);
      if (url.search && url.search.length > 1) {
        url.search += '&' + qs;
      } else {
        url.search = '?' + qs;
      }

      window.location.href = url.toString();
    });
  });
})();


/*progressbar */
(function () {
  function intOrNull(v) {
    if (v == null) return null;
    var n = parseInt(String(v).replace(/[^\d-]/g, ""), 10);
    return Number.isFinite(n) ? n : null;
  }

  function getBundleRoot(el) {
    return (
      el.closest(".lsg-bundle-block") ||
      el.closest(".lsg-bundle-form") ||
      el.parentElement
    );
  }

  function initOneProgress(progressWrap) {
    var root = getBundleRoot(progressWrap);
    if (!root) return;

    var leftEl = root.querySelector("[data-lsg-bundle-submit-button-add-more-quantity]");
    if (!leftEl) return;

    var fill = progressWrap.querySelector("[data-lsg-bundle-progress-fill]");
    var label = progressWrap.querySelector("[data-lsg-bundle-progress-label]");
    var bar = progressWrap.querySelector(".lsg-bundle-progress__bar");

    var maxLeft = intOrNull(progressWrap.getAttribute("data-max-left")) || null;

    function isBundleComplete() {
      var addMoreWrap = root.querySelector("[data-lsg-bundle-submit-button-add-more-text]");
      var atcWrap = root.querySelector("[data-lsg-bundle-submit-button-atc-text]");

      // Si "Add more" está hidden (y/o ATC visible), asumimos bundle completo
      return (
        (addMoreWrap && addMoreWrap.classList.contains("hidden")) ||
        (atcWrap && !atcWrap.classList.contains("hidden") && (!addMoreWrap || addMoreWrap.classList.contains("hidden")))
      );
    }

    function update() {
      var complete = isBundleComplete();
      var left = intOrNull(leftEl.textContent);

      if (complete) left = 0;

      // Si no hay número aún y no está completo, ocultamos
      if (left === null) {
        progressWrap.classList.add("is-hidden");
        return;
      }
      progressWrap.classList.remove("is-hidden");

      // Total dinámico = el máximo "left" visto (solo cuando left > 0)
      if (left > 0 && (maxLeft === null || left > maxLeft)) {
        maxLeft = left;
        progressWrap.setAttribute("data-max-left", String(maxLeft));
      }

      var total = Math.max(1, maxLeft || 1);
      var done = Math.max(0, Math.min(total, total - left));
      var pct = (done / total) * 100;

      if (complete) pct = 100;

      pct = Math.max(0, Math.min(100, pct));

      if (fill) fill.style.width = pct.toFixed(2) + "%";
      if (bar) bar.setAttribute("aria-valuenow", String(Math.round(pct)));
      if (label) label.textContent = complete ? "Complete" : (left + " packs left");

    }

    // Primer render
    update();

    // Observa cambios del número y cambios de clases (hidden/visible)
    var obs = new MutationObserver(update);

    obs.observe(leftEl, { childList: true, subtree: true, characterData: true });

    var addMoreWrap = root.querySelector("[data-lsg-bundle-submit-button-add-more-text]");
    if (addMoreWrap) obs.observe(addMoreWrap, { attributes: true, attributeFilter: ["class"] });

    var atcWrap = root.querySelector("[data-lsg-bundle-submit-button-atc-text]");
    if (atcWrap) obs.observe(atcWrap, { attributes: true, attributeFilter: ["class"] });
  }

  function initAll() {
    document.querySelectorAll("[data-lsg-bundle-progress]").forEach(initOneProgress);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();

